import get from 'lodash/get'
import { buildFetchMoreQuery } from './buildFetchMoreQuery'
import isEmpty from 'lodash/isEmpty'
import type { QueryResult } from '@apollo/client'
import type { DbOptions, ListActionResult, PageInfo, QueryInput } from '../types/QueryInput'
import type { UseListResult } from './index'

export const useBuildListQueryResults = <T = any>({
  queryResult,
  entity,
  limit,
  dbOptions,
  listActionResults,
}: {
  queryResult: QueryResult<T, any>
  entity: QueryInput['entity']
  limit?: QueryInput['limit']
  dbOptions?: DbOptions
  listActionResults?: ListActionResult
}): UseListResult<T> => {
  const { data, fetchMore } = queryResult || {}

  const list = get(data, entity, undefined)
  //get the pageInfo from server for backward compatibility, and if it's not available then use the new way
  const pageInfo = get(data, `${entity}Meta`) as PageInfo

  return {
    ...queryResult,
    pageInfo,
    list,
    loadMoreEntries(skip, searchString, sortObject) {
      return buildFetchMoreQuery({
        modelName: entity,
        fetchMore,
        skip,
        searchString,
        sortObject,
        limit,
        dbOptions,
      })
    },
    ...listActionResults,
    isEmpty: isEmpty(list) && !queryResult.loading,
  }
}
